All reasons why a position was not posted on SEEK, identified by the partner's position ID.
